import { createAsyncActionTypes, createAction } from '@mews/framework';
import { ApplicationState, AsyncAction, CommanderThunkAction, WithEnterpriseId } from '@mews-commander/types';
import { RoutingRule, RoutingRuleUpdateParameters } from '@mews-commander/data-access';
import { createFetchAction } from '@mews-commander/utils';
import parentSelector from '../selector';
import prefix from '../prefix';
import { createScopedEntitiesReducer, createScopedBaseEntitySelectors } from './utils';

export const NAME = 'routingRules';

export const ROUTING_RULES_FETCH = prefix('ROUTING_RULES_FETCH');
export const [ROUTING_RULES_FETCH_STARTED, ROUTING_RULES_FETCH_SUCCEEDED, ROUTING_RULES_FETCH_FAILED] =
    createAsyncActionTypes(ROUTING_RULES_FETCH);
export const ROUTING_RULES_UPDATE = prefix('ROUTING_RULES_UPDATE');
export const [ROUTING_RULES_UPDATE_STARTED, ROUTING_RULES_UPDATE_SUCCEEDED, ROUTING_RULES_UPDATE_FAILED] =
    createAsyncActionTypes(ROUTING_RULES_UPDATE);
export const ROUTING_RULES_DELETE = prefix('ROUTING_RULES_DELETE');
export const [ROUTING_RULES_DELETE_STARTED, ROUTING_RULES_DELETE_SUCCEEDED, ROUTING_RULES_DELETE_FAILED] =
    createAsyncActionTypes(ROUTING_RULES_DELETE);

export const updateRoutingRules =
    ({
        routingRuleUpdates,
        enterpriseId,
    }: { routingRuleUpdates: RoutingRuleUpdateParameters[] } & WithEnterpriseId): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.routingRules
            .update({ routingRuleUpdates, enterpriseId })
            .then(({ routingRules }) => routingRules);

        return dispatch(createFetchAction(ROUTING_RULES_UPDATE, promise, { scope: enterpriseId }));
    };

export const deleteRoutingRules =
    ({
        routingRuleIds,
        enterpriseId,
    }: WithEnterpriseId & { routingRuleIds: string[] }): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { repositories }) => {
        const promise = repositories.routingRules.delete({ routingRuleIds, enterpriseId });
        return dispatch(createFetchAction(ROUTING_RULES_DELETE, promise, { scope: enterpriseId }));
    };

export const [getRoutingRules, getRoutingRulesByIds, getRoutingRulesByOwnerId, getRoutingRule] =
    createScopedBaseEntitySelectors<ApplicationState, RoutingRule, typeof NAME, 'enterpriseId'>(
        parentSelector,
        NAME,
        'enterpriseId'
    );

export const setRoutingRules = (entities: RoutingRule[], scope: string) =>
    createAction(ROUTING_RULES_FETCH_SUCCEEDED, { entities }, { scope });

export const routingRulesReducer = createScopedEntitiesReducer({
    FETCH_SUCCESS: ROUTING_RULES_FETCH_SUCCEEDED,
    UPDATE_SUCCESS: ROUTING_RULES_UPDATE_SUCCEEDED,
    DELETE_SUCCESS: ROUTING_RULES_DELETE_SUCCEEDED,
});
